module.exports = __webpack_public_path__ + "static/media/bordeQuesoBocadillo.b61a4ed9.jpg";